import { fromJS } from 'immutable'
// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_SET_STATUS,
} from './constants';

export function setStatus(status) {
  return {
    type: COMMON_SET_STATUS,
    data: status
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_STATUS:
      return {
        ...state,
        status: fromJS(action.data)
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setStatus.js